import { getObjectUtil } from 'packages/src'
import { getIdReduxUtil } from '../../../redux/utils/get-id'
import getCurrentWorkoutExerciseIndexStartWorkoutSelect from '../get-current-workout-exercise-index'
import getCurrentWorkoutSectionStartWorkoutSelect from '../get-current-workout-section'
import { WORKOUT_EXERCISES_PATH } from '../../../workout-exercise/redux/constants'
import getWorkoutExercisesWorkoutSectionUtil from '../../../workout-section/model/utils/get-workout-exercises'
import { createSelector } from 'reselect'

const getNextWorkoutExerciseSelect = createSelector(
  state => getObjectUtil(state, WORKOUT_EXERCISES_PATH.DATA),
  getCurrentWorkoutExerciseIndexStartWorkoutSelect,
  getCurrentWorkoutSectionStartWorkoutSelect,
  (workoutExercisesDomainMap, curWorkoutExerciseIndex, curWorkoutSection) => {
    if (!curWorkoutSection) {
      return
    }
    const curWorkoutExercisePointers = getWorkoutExercisesWorkoutSectionUtil(
      curWorkoutSection)
    const nextExerciseIndex = curWorkoutExerciseIndex + 1
    const nextWorkoutExercisePointer = (
      curWorkoutExercisePointers[nextExerciseIndex]
    )
    if (!nextWorkoutExercisePointer) {
      return
    }
    const id = getIdReduxUtil(nextWorkoutExercisePointer)
    return workoutExercisesDomainMap[id]
  }
)

export default getNextWorkoutExerciseSelect
